import React, { useEffect, useState, useRef } from 'react';
import TabsPrestasi from '../../tabs/TabsPrestasi';
import Artikel from '../../artikel/Artikel';
import { useApi } from '../../../hooks/api';

import './PrestasiSection.css';
import ButtonLoadmore from '../../button/ButtonLoadmore';

const PrestasiSection = () => {
  const titlePrestasi = "🏆 Prestasi Yang Diraih";
  const urlApiKeegiatan = "/api/prestasi-sekolah/status";

  const payloadSiswa = {
    pagination: { current: 1, pageSize: 6 },
    filtering: { kategori: "Siswa" }
  };
  const payloadGuru = {
    pagination: { current: 1, pageSize: 6 },
    filtering: { kategori: "Guru" }
  };
  const payloadMadrasah = {
    pagination: { current: 1, pageSize: 6 },
    filtering: { kategori: "Madrasah" }
  };

  const [activeKey, setActiveKey] = useState('siswa');
  const fetchedTabs = useRef(new Set());

  const { data: dataSiswa, loading: loadingSiswa, refetch: refetchSiswa } = useApi(urlApiKeegiatan);
  const { data: dataGuru, loading: loadingGuru, refetch: refetchGuru } = useApi(urlApiKeegiatan);
  const { data: dataMadrasah, loading: loadingMadrasah, refetch: refetchMadrasah } = useApi(urlApiKeegiatan);

  const fetchTabData = (key) => {
    if (key === 'siswa' && !fetchedTabs.current.has('siswa')) {
      fetchedTabs.current.add('siswa');
      refetchSiswa("POST", payloadSiswa);
    } else if (key === 'guru' && !fetchedTabs.current.has('guru')) {
      fetchedTabs.current.add('guru');
      refetchGuru("POST", payloadGuru);
    } else if (key === 'madrasah' && !fetchedTabs.current.has('madrasah')) {
      fetchedTabs.current.add('madrasah');
      refetchMadrasah("POST", payloadMadrasah);
    }
  };

  useEffect(() => {
    fetchTabData(activeKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  const itemsTabs = [
    {
      key: 'siswa',
      label: 'Siswa',
      children: <div>
        <Artikel isLoading={loadingSiswa} items={dataSiswa && dataSiswa.list} onRefetch={() => {
          refetchSiswa("POST", payloadSiswa);
        }} />
        <ButtonLoadmore payload={payloadSiswa} isShow={dataSiswa && dataSiswa.list && dataSiswa.list.length > 0 ? true : false} refetch={() => refetchSiswa("POST", payloadSiswa)} />
      </div>,
    },
    {
      key: 'guru',
      label: 'Guru',
      children: <div>
        <Artikel isLoading={loadingGuru} items={dataGuru && dataGuru.list} onRefetch={() => {
          refetchGuru("POST", payloadGuru);
        }} />
        <ButtonLoadmore payload={payloadGuru} isShow={dataGuru && dataGuru.list && dataGuru.list.length > 0 ? true : false} refetch={() => refetchGuru("POST", payloadGuru)} />
      </div>,
    },
    {
      key: 'madrasah',
      label: 'Madrasah',
      children: <div>
        <Artikel isLoading={loadingMadrasah} items={dataMadrasah && dataMadrasah.list} onRefetch={() => {
          refetchMadrasah("POST", payloadMadrasah);
        }} />
        <ButtonLoadmore payload={payloadMadrasah} isShow={dataMadrasah && dataMadrasah.list && dataMadrasah.list.length > 0 ? true : false} refetch={() => refetchMadrasah("POST", payloadMadrasah)} />
      </div>,
    },
  ];

  return (
    <section id="prestasi" className="prestasi-section">
      <div className="feature-header title-prestasi">
        <div className="divider-line"></div>
        <h2>{titlePrestasi}</h2>
      </div>
      <TabsPrestasi title={titlePrestasi} items={itemsTabs} activeKey={activeKey} onChange={handleTabChange} />
    </section>
  );
};

export default PrestasiSection;
